export default {
  'department.department': 'Департамент',
  'department.name': 'Название Департамента',
  'department.perisanname': 'Персидское название отдела',
  'department.englishname': 'Английское название отдела',
  'department.code': 'Код  Департамента',
  'department.add': 'Добавить  Департамент',
  'department.title': 'Управление Департаментом',
  'department.departmentdel': 'Удалить  Департамент',
  'department.departmentadd': 'Департамент успешно добавлен!',
  'department.departmentdelete': 'Департамент успешно удален!',
  'department.deleteerror': 'Запись была использована другими записями',
  'department.departmentaddInformation':
    'Ваша информация была успешно отредактирована',
};
